export default __webpack_public_path__ + "static/media/importsPage3Dark.19ec4fe8.png";